import type { RemovableRef, UseStorageOptions } from '@vueuse/core'

import { useLocalStorage, useSessionStorage } from '@vueuse/core'

/**
 * 缓存存储实例，避免重复创建
 * 分别缓存 localStorage 和 sessionStorage
 */
const localStorageCache: Record<string, RemovableRef<any>> = {}
const sessionStorageCache: Record<string, RemovableRef<any>> = {}

/**
 * 获取或创建 localStorage 实例
 */
export function getCachedLocalStorage<T>(
  key: string,
  defaultValue: T,
  options?: UseStorageOptions<T>,
): RemovableRef<T> {
  if (!localStorageCache[key]) {
    const storageOptions = options || (
      typeof defaultValue === 'object' && defaultValue !== null
        ? {
            serializer: {
              read: (v: string) => (v ? JSON.parse(v) : defaultValue),
              write: (v: T) => JSON.stringify(v),
            },
          }
        : undefined
    )

    localStorageCache[key] = useLocalStorage<T>(key, defaultValue, storageOptions)
  }
  return localStorageCache[key]
}

/**
 * 获取或创建 sessionStorage 实例
 */
export function getCachedSessionStorage<T>(
  key: string,
  defaultValue: T,
  options?: UseStorageOptions<T>,
): RemovableRef<T> {
  if (!sessionStorageCache[key]) {
    const storageOptions = options || (
      typeof defaultValue === 'object' && defaultValue !== null
        ? {
            serializer: {
              read: (v: string) => (v ? JSON.parse(v) : defaultValue),
              write: (v: T) => JSON.stringify(v),
            },
          }
        : undefined
    )

    sessionStorageCache[key] = useSessionStorage<T>(key, defaultValue, storageOptions)
  }
  return sessionStorageCache[key]
}
